import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Widget/AddToBag.js";

window.HSN = window.HSN || {};

/**
* class HSN.DynamicCarouselHelper
* Helper class for Dynamic Carousels
**/
HSN.DynamicCarouselHelper = function() {
    var deviceInfo = HSN.Instance().DeviceInformation;
    var pageName = dataLayer[0].page_name;
    var pageType = dataLayer[0].page_type;
    var isCartPage = pageName === 'Cart' && pageType === 'Checkout';
    var isOrderReviewPage = pageName === 'Order Review' && pageType === 'Checkout';
    var isMobile = deviceInfo.IsMobile && !deviceInfo.IsTablet;

    var handlerAddToBag = function(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        var cur = $(ev.currentTarget);
        var data = cur.data();

        HSN.Instance().GetProductPreviewOffCanvas().Show(data.productId);

        return false;
    };

    var attachAddToBagHandlers = function(container) {
        container.on('click', '.dc-add-to-bag', handlerAddToBag);
    };

    var enable = function(config) {
        if (!config.container) {
            return;
        }
        if (config.addToBag) {
            attachAddToBagHandlers(config.container);
        }
    };

    return {
        Enable: enable
    }
};




// WEBPACK FOOTER //
// ./assets/js/HSN/DynamicCarouselHelper.js